import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SettingService } from '@src/domain/services';


interface ItemList extends SettingService.GetItemListByCategoryRespBo {}

export interface SettingState {
  itemList: ItemList | null;
}

/** 設定 */
export const settingSlice = createSlice({
  name: 'setting',
  initialState: {
    /** 設定清單 */
    itemList: null
  } as SettingState,
  reducers: {
    setItemList(state, action: PayloadAction<ItemList>) {
      state.itemList = action.payload
    },
    clearItemList(state) {
      state.itemList = null
    }
  },
});

export const settingReducer = settingSlice.reducer
export const settingActions = settingSlice.actions
